"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lookUpVehicleQuery = void 0;
exports.lookUpVehicleQuery = `
  query LookUpVehicle($input: ItemFilterFields) {
    search(filter: { include: $input }) {
      aggregations {
        totalResults
      }
      edges {
        node {
          path
        }
      }
    }
  }
`;
//# sourceMappingURL=vehicle-lookup.js.map